import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ThemeService from 'themes/ThemeService';

import styles from './CampaignRegistrationOverlay.css';


const emoji = '\ud83c\udf34';

const CampaignRegistrationOverlay = (props) => {
  const { className } = props;
  const theme = ThemeService?.theme?.registrationOverlay;

  if (!theme?.title) {
    return null;
  }

  const containerClasses = classNames(
    styles.campaignRegistrationWrapper,
    className,
  );

  const titleClasses = classNames(
    styles.campaignRegistrationTitle,
    theme.titleClass,
  );

  const containerStyle = { backgroundImage: `url(${theme.backgroundImage})` };

  return (
    <div
      className={containerClasses}
      data-vwo-id="registration-modal-left-column"
      style={containerStyle}
    >
      <div className={styles.campaignRegistrationBody}>
        <div className={titleClasses}>
          {emoji}
          <br />
          {theme.title}
        </div>
        <div>{theme.text}</div>
      </div>
    </div>
  );
};

CampaignRegistrationOverlay.propTypes = { className: PropTypes.string };

CampaignRegistrationOverlay.defaultProps = { className: undefined };

export default CampaignRegistrationOverlay;
